module.exports = __webpack_public_path__ + "static/media/pp-fav.a364bda2.ico";